import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useHelp } from './HelpProvider'

interface HelpNavigationBoxProps {
  totalSteps: number
}

const HelpNavigationBox: React.FC<HelpNavigationBoxProps> = ({ totalSteps }) => {
  const { currentStep, nextStep, prevStep, stopHelp } = useHelp()

  if (currentStep === null) return null

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 70,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'background.help',
        padding: 2,
        borderRadius: 2,
        boxShadow: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        zIndex: 1800, // on top of everything
        '.MuiDataGrid-overlay': {
          pointerEvents: 'none',
          height: '100%',
        },
      }}
    >
      <Typography variant="body1">{`${currentStep + 1} / ${totalSteps}`}</Typography>
      <Stack direction="row" spacing={2}>
        <Button variant="outlined" size="small" onClick={prevStep} disabled={currentStep === 0}>
          Back
        </Button>
        {currentStep < totalSteps - 1 ? (
          <Button variant="contained" size="small" onClick={nextStep}>
            Next
          </Button>
        ) : (
          <Button variant="contained" size="small" onClick={stopHelp}>
            Finish
          </Button>
        )}
      </Stack>
    </Box>
  )
}

export default HelpNavigationBox
